import { Link } from 'react-router-dom';

const footerLinks = {
  product: {
    title: '品种系列',
    links: [
      { label: '翠冠梨', path: '/category/cuiguan' },
      { label: '黄花梨', path: '/category/huanghua' },
      { label: '丰水梨', path: '/category/fengshui' },
      { label: '雪花梨', path: '/category/xuehua' },
    ],
  },
  company: {
    title: '关于我们',
    links: [
      { label: '品牌故事', path: '/about#story' },
      { label: '口碑评价', path: '/about#testimonials' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  articles: {
    title: '梨果资讯',
    links: [
      { label: '产品动态', path: '/articles' },
      { label: '梨果知识', path: '/articles' },
      { label: '美食食谱', path: '/articles' },
      { label: '健康养生', path: '/articles' },
    ],
  },
  support: {
    title: '客户服务',
    links: [
      { label: '购买指南', path: '/articles/article-7' },
      { label: '常见问题', path: '/#faq' },
      { label: '团购咨询', path: '/about#contact' },
    ],
  },
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10">
            <div className="col-span-2 md:col-span-1">
              <Link
                to="/"
                className="flex items-center gap-2 mb-4 cursor-pointer"
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-leaf-fill text-xl text-background-50"></i>
                </div>
                <span className="font-heading text-xl font-bold text-background-50 whitespace-nowrap">
                  惠美梨
                </span>
              </Link>
              <p className="text-background-400 text-sm leading-relaxed mt-3">
                品质优选，甜蜜直达你的餐桌
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微信">
                  <i className="ri-wechat-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="微博">
                  <i className="ri-weibo-line text-lg"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" aria-label="小红书">
                  <i className="ri-red-packet-line text-lg"></i>
                </a>
              </div>
            </div>

            {Object.values(footerLinks).map((section) => (
              <div key={section.title}>
                <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">
                  {section.title}
                </h4>
                <ul className="flex flex-col gap-2.5">
                  {section.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.path}
                        className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {currentYear} 惠美梨 版权所有
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">
                隐私政策
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">
                服务条款
              </a>
              <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">
                备案信息
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}